import React, { useEffect, useState } from "react";
import {
    Avatar,
    Box,
    Card,
    CardContent,
    CircularProgress,
    Divider,
    Pagination,
    Typography,
    useTheme,
} from "@mui/material";
import axios from "axios";
import { useParams } from "react-router-dom";

const CommentCard = ({ comment }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "row", mb: 2 }}>
            <Avatar src={comment.user_image} alt={comment.user_username} sx={{ mr: 2 }} />
            <Box flex={1}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="subtitle2" color="text.primary">
                        {comment.user_username}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {new Date(comment.time).toLocaleString()}
                    </Typography>
                </Box>
                <Typography variant="body2" sx={{ mt: 0.5 }}>
                    {comment.message}
                </Typography>
                {comment.vote && (
                    <Typography variant="caption" sx={{ mt: 0.5, display: "block", color: "text.secondary" }}>
                        👍 {comment.vote.upvotes} | 👎 {comment.vote.downvotes}
                    </Typography>
                )}
                {comment.pinned && (
                    <Typography variant="caption" color="warning.main">
                        📌 Pinned
                    </Typography>
                )}
                <Divider sx={{ mt: 1 }} />
            </Box>
        </Box>
    );
};

const TokenComments = ({ tokenId, limit = 10, community = 0 }) => {
    // const { id: tokenId } = useParams(); // expects <Route path="/tokens/:id" ...>
    const theme = useTheme();
    const [comments, setComments] = useState([]);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!tokenId) return;
        setLoading(true);
        axios
            .get(`https://api.odin.fun/v1/token/${ tokenId }/comments`, {
                params: {
                    page,
                    limit,
                    community,
                },
            })
            .then((res) => {
                setComments(res.data.data || []);
                setCount(res.data.count || 0);
            })
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, [tokenId, page, limit, community]);

    if (loading) {
        return (
            <Box sx={{ textAlign: "center", mt: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Typography color="error" align="center" sx={{ mt: 2 }}>
                Failed to load comments: {error}
            </Typography>
        );
    }

    return (
        <Card sx={{ borderRadius: 2, boxShadow: 2, m: 2 }}>
            <CardContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Comments
                </Typography>
                {comments.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        No comments yet.
                    </Typography>
                ) : (
                    comments.map((comment) => (
                        <CommentCard comment={comment} key={comment.id} />
                    ))
                )}
                {count > limit && (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                        <Pagination
                            page={page}
                            count={Math.ceil(count / limit)}
                            onChange={(e, val) => setPage(val)}
                            size="small"
                            color="primary"
                        />
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default TokenComments;
